// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1Y_29","label":"Section_label__32msq","contentWrap":"Section_contentWrap__17RXc","footer":"Section_footer__vH2Tu","footerInner":"Section_footerInner__1LD3M"};